import { Injectable } from '@angular/core';
import { ServerPath } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { retry, catchError, map } from 'rxjs/operators';
import { User } from '../data-models/user.class';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  authServer = ServerPath;

  constructor(private http: HttpClient) { }

  getUsers(filters) {

    return this.http.post(this.authServer.users, JSON.stringify(filters))

      .pipe(
        // retry(3),
        map((res: Response) => {
          //console.log('result from users: ', res);
          return res;
        })
        // catchError(this.handleError)
      )
  }

  getPPList() {
    return this.http.get(this.authServer.users + 'pplist')
      .pipe(
        map((res: Response) => {
          return res;
        })
      )
  }

  getUserById(id) {
    return this.http.get(this.authServer.users + 'list/' + id)
      .pipe(
        // retry(3),
        map((res: Response) => {
          return res;
        })
        // catchError(this.handleError)
      )
  }

  updateUser(user: User) {
    const body = JSON.stringify(user);
    //console.log(body);
    return this.http.post(this.authServer.users + 'updateUsr/', body)
      .pipe(
        // retry(3),
        // catchError(this.handleError)
      )
  }

  updateUserById(status, id) {
    const body = {
      status: status,
      id: id
    }

    //console.log(body);
    return this.http.post(this.authServer.users + 'updateUsrById/', body)
      .pipe(
        // retry(3),
        // catchError(this.handleError)
      )
  }

  sendLink(id) {
    return this.http.get(this.authServer.users + 'resetPasswordLink/' + id)
      .pipe(
        // retry(3),
        map((res: Response) => {
          return res;
        })
        // catchError(this.handleError)
      )
  }

  getProfile() {
    return this.http.get(this.authServer.profile)
      .pipe(
        map((res: Response) => {
          return res;
        })
      )
  }

  getUsersForMessageCenter(filters){
    return this.http.post(this.authServer.users + 'message-center', JSON.stringify(filters))

    .pipe(
      // retry(3),
      map((res: Response) => {
        //console.log('result from users: ', res);
        return res;
      })
      // catchError(this.handleError)
    )
  }

  getBusinessLicensee() {
    return this.http.get(this.authServer.businessLicenseeData)
      .pipe(
        map((res: Response) => {
          return res;
        })
      )
  }

  getDropDownText(id, object) {
    const selObj = _.filter(object['companyList'], function (o) {
      return (_.includes(id,o.clnt_id));
    });
    return selObj;
  }
}